import { Component, type ErrorInfo, type ReactNode } from "react";
import { CrashScreen } from "./CrashScreen.js";

/**
 * Граница ошибок снаружи роутера (провайдеры, сам роутер). Ошибки страниц ловит `errorElement` корневого маршрута
 * с тем же `CrashScreen`. Классовый компонент: у React нет хука для перехвата ошибок рендера.
 */
export class ErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  override state = { failed: false };

  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("Ошибка отрисовки", error, info.componentStack);
  }

  override render(): ReactNode {
    return this.state.failed ? <CrashScreen /> : this.props.children;
  }
}
